

import React, { Component } from "react"
import { connect } from "react-redux"
import {  reduxForm, propTypes } from 'redux-form'
import {
  Row,
  Col,
  Panel,
  Button,
  FormGroup
} from "react-bootstrap"
import { PropTypes } from "prop-types"
import { URL } from '../../../config'
import { postRequest } from '../../../utils/httpRequest'
import { warning,exceptiontypes,red,green,blue } from '../../../utils/constants'

const recordDetails = { 
  paddingTop:'6px',
  paddingBottom:'6px' 
}

class ExceptionType extends Component {
  static propTypes = {
    ...propTypes
  }
  constructor(props)
  {
    super(props)
    this.state = {
      reconciling:false,
      confirming:false,
      ignoring:false
    }
    this.handleConfirm = this.handleConfirm.bind(this)
    this.handleReconcile = this.handleReconcile.bind(this)
    this.handleIgnore = this.handleIgnore.bind(this)
    this.generateBowlerInformation  = this.generateBowlerInformation.bind(this)
    this.getAccountedForReasonColor = this.getAccountedForReasonColor.bind(this)
  }
  ReconcileBy =
  {
    System:'system',
    Score:'score'
  }
  handleReconcile()
  {
    const { individualCombinedScoresId,eventId,exceptionId } = this.props.exception
    this.setState({ reconciling:true })
    const exceptionsendpoint = `${eventId}/exceptions/${exceptionId}/${individualCombinedScoresId}/reconcile`
    const token = this.props.oidc.user.access_token
    const  exceptionsURL =  `${URL.event}/${exceptionsendpoint}` 
    const _this = this
    postRequest(exceptionsURL,'json',token).then(function(response){
      _this.setState({ 
        reconciling:false
      })
      console.log('Reconcile response', response)
      _this.props.exceptionUpdated(eventId)
    })
  }
  handleConfirm()
  {
    const { 
      individualCombinedScoresId,
      eventId,
      exceptionId 
    } = this.props.exception

    this.setState({ confirming:true })
    const exceptionsendpoint = `${eventId}/exceptions/${exceptionId}/${individualCombinedScoresId}/confirm`
    const token = this.props.oidc.user.access_token
    const  exceptionsURL =  `${URL.event}/${exceptionsendpoint}` 
    const _this = this
    postRequest(exceptionsURL,'json',token).then(function(response){
      _this.setState({ 
        confirming:false
      })
      console.log('Confirm response', response)
      _this.props.exceptionUpdated(eventId)
    })
  }
  handleIgnore()
  {
    const { individualCombinedScoresId,eventId,exceptionId } = this.props.exception
    this.setState({ ignoring:true })
    const exceptionsendpoint = `${eventId}/exceptions/${exceptionId}/${individualCombinedScoresId}/ignore`
    const token = this.props.oidc.user.access_token
    const  exceptionsURL =  `${URL.event}/${exceptionsendpoint}` 
    const _this = this
    postRequest(exceptionsURL,'json',token).then(function(response){
      _this.setState({ 
        ignoring:false
      })
      console.log('Ignore response', response)
      _this.props.exceptionUpdated(eventId)
    })
  }
  generateBowlerInformation(exception)
  {
    const { bowler,bowlerId,school,division,divisionVJV, comment } = exception
    return (  <label style={recordDetails}><span style={{ fontWeight:'bold' }}>{school}</span>&nbsp;&nbsp;{bowler}&nbsp;&nbsp; {bowlerId}{', '}&nbsp;{division}&nbsp;division&nbsp;{divisionVJV},&nbsp;{comment}</label>)
  }
	generateExceptioTypeControls()
	{
		//const { exceptionTypeId,bowler,bowlerId,school,division } = this.props.exception
    const { exception }       = this.props
    const { exceptionTypeId } = exception

		switch(exceptionTypeId) {
			case exceptiontypes.InvalidMemberId:
			{
      return (
        <div>
          <FormGroup>
            <Col>
              {this.generateBowlerInformation(exception)}
            </Col>
          </FormGroup>                       
        </div>
      )
      }
			case exceptiontypes.MismatchName:
      return (
        <div>
          <FormGroup>
            <Col>
              {this.generateBowlerInformation(exception)}
            </Col>
          </FormGroup>                       
        </div>
      )
			case exceptiontypes.MismatchSchool:
      return (
        <div>
          <FormGroup>
            <Col>
              {this.generateBowlerInformation(exception)}
            </Col>
          </FormGroup>                       
        </div>
      )      
			case exceptiontypes.EligibilityFlag:
      return (
        <div>
          <FormGroup>
            <Col>
              {this.generateBowlerInformation(exception)}
            </Col>
          </FormGroup>                       
        </div>
      )
			case exceptiontypes.InvalidEventRosterSize:
      return (
        <div>
          <FormGroup>
            <Col>
              {this.generateBowlerInformation(exception)}
            </Col>
          </FormGroup>                       
        </div>
      )      
			case exceptiontypes.InvalidSeasonRosterSize:
      return (
        <div>
          <FormGroup>
            <Col>
              {this.generateBowlerInformation(exception)}
            </Col>
          </FormGroup>                       
        </div>
      )            
      case exceptiontypes.InvalidAcademicEligibility:
			{
        return (
          <div>
            <FormGroup>
              <Col>
                {this.generateBowlerInformation(exception)}
              </Col>
            </FormGroup>                       
          </div>
        )
      }      
      case exceptiontypes.ExceededMaxSeasonsEligibility:
			{
        return (
          <div>
            <FormGroup>
              <Col>
                {this.generateBowlerInformation(exception)}
              </Col>
            </FormGroup>                       
          </div>
        )
      }  
      case exceptiontypes.GameTotMoreThan5xNoOfGames:
			{
        return (
          <div>
            <FormGroup>
              <Col>
                {this.generateBowlerInformation(exception)}
              </Col>
            </FormGroup>                       
          </div>
        )
      }                
      case exceptiontypes.GameTotLessThen5xNoOfGames:
			{
        return (
          <div>
            <FormGroup>
              <Col>
                {this.generateBowlerInformation(exception)}
              </Col>
            </FormGroup>                       
          </div>
        )
      }    
      case exceptiontypes.BakerGameTotLessThanRequired:
			{
        return (
          <div>
            <FormGroup>
              <Col>
                {this.generateBowlerInformation(exception)}
              </Col>
            </FormGroup>                       
          </div>
        )
      }                     
      case exceptiontypes.TeamUsedIneligibleBowler:
			{
        return (
          <div>
            <FormGroup>
              <Col>
                {this.generateBowlerInformation(exception)}
              </Col>
            </FormGroup>                       
          </div>
        )
			}                        
			default:
					break
	}
  }
  getAccountedForReasonColor()
  { const { accountedForReason } = this.props.exception
    let color = green

    if(accountedForReason == 'Exception Ignored')
    {
       color = red
    }
    else if (accountedForReason == 'Exception Reconciled')
    {
       color = blue
    }
    
    return color
    
  }
  render()
    {
			const { exception, index,action } = this.props
      const { exceptionType,exceptionTypeId,accountedForReason } = exception
      const { reconciling, confirming ,ignoring } = this.state
      const showIgnoreButton = (exceptionTypeId == exceptiontypes.EligibilityFlag) || (exceptionTypeId == exceptiontypes.InvalidAcademicEligibility) || (exceptionTypeId == exceptiontypes.ExceededMaxSeasonsEligibility)
      const accountForReasonColor = this.getAccountedForReasonColor()
      const reconcile = action == 'Reconcile'
      const view = action == 'View'
        return (
        
          <Panel style={{ maxWidth:'98%',marginLeft:'1%',minHeight:'70px',maxHeight:'130px',paddingTop:'2px',paddingBottom:'0' }}>
            <div className="content-heading" style={{ color:warning }}><span style={{ fontWeight:'bold' }}>{index}. Exception Type:</span>&nbsp;&nbsp;<span style={{ fontSize:'16px' }}>{exceptionType}</span></div>
            <div sm={12}>
              <Row>
              <Col sm={12}>
                <div className="stacked-filter-panel" sm={12} >
                  <Row style={{ padding:'0',margin:'0' }}> 
                      <Col sm={12}>
                        <form className="form-horizontal" sm={12}> 
                          {this.generateExceptioTypeControls()}          
                          {/* <FormGroup> */}
                            <Row style={{ marginTop:'5px',marginBottom:'-25px' }}>
                             {
                                reconcile && (<Col sm={ 12 } >
                                  <Button  bsStyle="default" style={{ minWidth:'90px', paddingLeft:'10px',fontSize:'14px'  }} onClick={this.handleConfirm} disabled={reconciling}>
                                    <i className={confirming ? 'fa fa-spinner fa-spin': 'fa fa-check'} aria-hidden='true' style={{ color:green }}/>&nbsp;Confirm Exception
                                  </Button>{' '}
                                  <Button  bsStyle="default" style={{ minWidth:'150px', paddingLeft:'10px',marginLeft:'10px',fontSize:'14px' }} onClick={this.handleReconcile} disabled={confirming} >
                                    <i className={reconciling ? 'fa fa-spinner fa-spin':'fa fa-arrow-right'} aria-hidden='true' style={{ color:blue }}/>&nbsp;&nbsp;Reconciled
                                  </Button> 
                                  {
                                    showIgnoreButton && (<Button  bsStyle="default" style={{ minWidth:'150px', paddingLeft:'10px',marginLeft:'10px',fontSize:'14px' }} onClick={this.handleIgnore} disabled={confirming} >
                                      <i className={ignoring ? 'fa fa-spinner fa-spin':'fa fa-times-circle'} aria-hidden='true' style={{ color:red }}/>&nbsp;&nbsp;Ignore Exception
                                    </Button>)
                                  }
                                </Col>)
                             }
                             {
                               view && (
                               <Col sm={ 12 } style={{ color:accountForReasonColor }} >
                                  <i className='fa fa-info-circle' aria-hidden='true' />&nbsp;&nbsp;<span style={{ fontSize:'110%',fontWeight:'bold' }}>{accountedForReason}</span>
                               </Col>)
                             }
                            </Row>
                          {/* </FormGroup> */}
                        </form>
                  
              </Col>
                  </Row>
                  </div>
              </Col>
            </Row> 
            </div>
        </Panel>
       
        )
    }
}


ExceptionType.propTypes = {
  oidc: PropTypes.object,
  dispatch:PropTypes.func,
	reset:PropTypes.func,
	exception:PropTypes.object,
  index:PropTypes.number,
  exceptionUpdated:PropTypes.func,
  action:PropTypes.string
}

const mapDispatchToProps = () => ({

})

const mapStateToProps = ({  oidc }) => {
	return {
		oidc: { ...oidc }
	}
}

export default reduxForm({
  form:'event'
})(
    connect(mapStateToProps,mapDispatchToProps)(ExceptionType)
);




// WEBPACK FOOTER //
// ./src/components/pages/Event/ExceptionType.js